import React from "react";
import Joi from "joi-browser";
import Form from "./common/form";
import * as userService from '../services/userService';
import { toast } from "react-toastify";

class ForgotPasswordForm extends Form {
  state = {
    data: { email: "" },
    errors: {}
  };

  schema = {
    email: Joi.string()
      .required()
      .email()
      .label("Email")
  };

  doSubmit = async () => {
    try {
      toast.info(
        "Please check your email to reset your password"
      );
      await userService.forgotPassword(this.state.data.email);
    }
    catch(ex) {
      if (ex.response && ex.response.status === 400) {
        const errors = { ...this.state.errors };
        errors.username = ex.response.data;
        this.setState({ errors });
      }
    }
  };

  render() {
    return (
      <div>
        <h1>Forgot your Password?</h1>
        <form onSubmit={this.handleSubmit}>
          {this.renderInput("email", "Email")}
          {this.renderButton("Forgot Password")}
        </form>
      </div>
    );
  }
}

export default ForgotPasswordForm;